// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/x-circle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/x-circle'

import { Icon, type IconComponentProps } from '../icon'

export const XCircleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
